var exports = {
  "q": "GifIndicator.module__indicator___ekhTV2",
};

module.exports = exports;
